import { action, call, resource, spawn } from "../deps.js";
export function raceMap(opMap) {
    return resource(function* Race(provide) {
        const keys = Object.keys(opMap);
        const taskMap = {};
        const resultMap = {};
        const winner = yield* action(function* (resolve) {
            for (let i = 0; i < keys.length; i += 1) {
                const key = keys[i];
                yield* spawn(function* () {
                    const task = yield* spawn(function* () {
                        yield* call(opMap[key]);
                    });
                    taskMap[key] = task;
                    resultMap[key] = yield* task;
                    resolve(task);
                });
            }
        });
        for (let i = 0; i < keys.length; i += 1) {
            const key = keys[i];
            const task = taskMap[key];
            if (task === winner) {
                continue;
            }
            yield* spawn(() => task.halt());
        }
        yield* provide(resultMap);
    });
}
//# sourceMappingURL=race.js.map